export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Orientación sobre planes de salud',
      description: 'Te ayudo a entender las diferencias entre planes, coberturas y beneficios para que elijas el más adecuado para ti.',
      image: 'https://public.readdy.ai/ai/img_res/4f43486163ab1fde4865e52df6e45842.jpg',
      accent: 'from-teal-600/80 to-teal-800/90',
    },
    {
      icon: 'ri-calculator-line',
      title: 'Cotización y evaluación',
      description: 'Comparamos alternativas y evaluamos cuál se ajusta mejor a tu presupuesto.',
      image: 'https://readdy.ai/api/search-image?query=financial%20planning%20documents%20calculator%20on%20clean%20white%20desk%2C%20soft%20natural%20light%2C%20minimal%20modern%20office%2C%20neutral%20tones&width=500&height=500&seq=srv2&orientation=squarish',
      accent: 'from-slate-700/80 to-slate-900/90',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Acompañamiento comercial',
      description: 'Te guío en cada paso del proceso, desde la consulta inicial hasta la formalización.',
      image: 'https://readdy.ai/api/search-image?query=two%20people%20shaking%20hands%20in%20bright%20modern%20office%2C%20warm%20neutral%20background%2C%20professional%20business%20meeting%2C%20clean%20minimal%20setting&width=500&height=500&seq=srv3&orientation=squarish',
      accent: 'from-emerald-700/80 to-emerald-900/90',
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Resolución de dudas sobre beneficios',
      description: 'Respondo todas tus preguntas sobre coberturas, bonificaciones y prestaciones para que aproveches al máximo tu plan de salud.',
      image: 'https://readdy.ai/api/search-image?query=person%20reading%20health%20insurance%20documents%20at%20home%2C%20cozy%20bright%20interior%2C%20warm%20light%2C%20relaxed%20atmosphere%2C%20clean%20minimal%20background&width=800&height=500&seq=srv4&orientation=landscape',
      accent: 'from-cyan-700/80 to-cyan-900/90',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-6">
            <span className="text-sm font-medium text-teal-600 tracking-wide uppercase">Servicios</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Cómo te ayudo
          </h2>
          <p className="text-lg text-gray-600">
            Orientación personalizada en cada etapa de tu decisión de salud previsional
          </p>
        </div>

        {/* Mosaic Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">

          {/* Card 1 — Large (spans 2 cols en desktop) */}
          <div className="sm:col-span-2 lg:col-span-2 relative rounded-3xl overflow-hidden group cursor-pointer h-64 sm:h-72 lg:h-80">
            <img
              src={services[0].image}
              alt={services[0].title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className={`absolute inset-0 bg-gradient-to-t ${services[0].accent}`} />
            <div className="absolute inset-0 p-8 flex flex-col justify-end">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 backdrop-blur-sm">
                <i className={`${services[0].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">{services[0].title}</h3>
              <p className="text-white/80 text-sm leading-relaxed max-w-md">{services[0].description}</p>
            </div>
          </div>

          {/* Card 2 — Small */}
          <div className="relative rounded-3xl overflow-hidden group cursor-pointer h-64 sm:h-72 lg:h-80">
            <img
              src={services[1].image}
              alt={services[1].title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className={`absolute inset-0 bg-gradient-to-t ${services[1].accent}`} />
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl mb-3 backdrop-blur-sm">
                <i className={`${services[1].icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-1">{services[1].title}</h3>
              <p className="text-white/75 text-xs leading-relaxed">{services[1].description}</p>
            </div>
          </div>

          {/* Card 3 — Small */}
          <div className="relative rounded-3xl overflow-hidden group cursor-pointer h-64 sm:h-72 lg:h-80">
            <img
              src={services[2].image}
              alt={services[2].title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className={`absolute inset-0 bg-gradient-to-t ${services[2].accent}`} />
            <div className="absolute inset-0 p-6 flex flex-col justify-end">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl mb-3 backdrop-blur-sm">
                <i className={`${services[2].icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-1">{services[2].title}</h3>
              <p className="text-white/75 text-xs leading-relaxed">{services[2].description}</p>
            </div>
          </div>

          {/* Card 4 — Large (spans 2 cols en desktop) */}
          <div className="sm:col-span-2 lg:col-span-2 relative rounded-3xl overflow-hidden group cursor-pointer h-64 sm:h-72 lg:h-80">
            <img
              src={services[3].image}
              alt={services[3].title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className={`absolute inset-0 bg-gradient-to-t ${services[3].accent}`} />
            <div className="absolute inset-0 p-8 flex flex-col justify-end">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 backdrop-blur-sm">
                <i className={`${services[3].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">{services[3].title}</h3>
              <p className="text-white/80 text-sm leading-relaxed max-w-md">{services[3].description}</p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
